import React from 'react';
import tw from 'twin.macro';
import { Link } from 'gatsby';

import type { TwStyle } from 'twin.macro';

import { VARIANT } from '../../enums';

interface IconCardProps {
  variant: VARIANT;
  to: string;
  title: string;
}

const IconCard: React.FC<IconCardProps> = ({ variant, to, title, children }) => {
  const baseStyles = [
    // Box
    tw`flex items-end rounded-lg relative w-full h-full overflow-hidden pt-64`,
    // Border
    tw`border-b-12`,
    // Font
    tw`font-bold text-white text-lg md:(text-xl)`,
    // Transition
    tw`transition-colors duration-100 ease-in-out`
  ];

  let colourStyles: TwStyle[] = [];
  switch (variant) {
    case 'green':
      colourStyles = [tw`border-green hover:(border-green-900)`];
      break;
    case 'blue':
      colourStyles = [tw`border-blue hover:(border-blue-900)`];
      break;
  }

  return (
    <Link css={[...baseStyles, ...colourStyles]} to={to}>
      <div tw="absolute inset-0 z-10">{children}</div>
      <div tw="relative w-full bottom-0 left-0 px-4 bg-gradient-to-t from-black pt-24 pb-3 z-20">{title}</div>
    </Link>
  );
};

export default IconCard;
